import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

interface SampleResultData {
  year: number;
  positive: number;
  negative: number;
  pending: number;
  total: number;
}

interface Props {
  data: SampleResultData[];
  loading?: boolean;
}

export const SampleResultsChart = ({ data, loading }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={5}>Evolución de Resultados de Muestras</Title>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="positive" stackId="a" fill="#ff4d4f" name="Positivas" />
          <Bar dataKey="negative" stackId="a" fill="#52c41a" name="Negativas" />
          <Bar dataKey="pending" stackId="a" fill="#faad14" name="Pendientes" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
